// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection-module__hero__F6RzBqc","logos":"HeroSection-module__logos__gM668W1","pillars":"HeroSection-module__pillars__VPNYzdR"};